function TopHoldingsCard(props) {
  const colors = ['bg-secondary', 'bg-tertiary', 'bg-info', 'bg-danger', 'bg-purple'];
  const childItems = props.items.map((item, idx) => {
    const colorIdx = (idx + colors.length) % 4;
    return (
      <HoldingItem
        key={idx}
        text={item.text}
        percent={item.percent}
        color={colors[colorIdx]}
        recommendation={item.recommendation}
        recommendationBadgeClass={item.recommendationBadgeClass}
      />
    );
  });

  return (
    <div className="col-12 col-xl-3">
      <div className="card border-light shadow-sm">
        <div className="card-header border-bottom border-light">
          <h2 className="h5 mb-0">Top Holdings</h2>
        </div>
        <div className="card-body">
          {childItems}
        </div>
      </div>
    </div>
  );
}

function HoldingItem(props) {
  const barStyle = {
    width: props.percent + '%'
  };

  return (
    <div className="row align-items-center dashboard-holding-item">
      <div className="col">
        <div className="progress-wrapper">
          <div className="progress-info">
            <div className="progress-label">
              <span>{props.text}</span>
            </div>
            <div className="progress-percentage d-flex align-items-center justify-content-end">
              {props.recommendation && props.recommendationBadgeClass && (
                <span className={`badge badge-pill analyst-rating-pill ${props.recommendationBadgeClass} mr-2`}>
                  {props.recommendation}
                </span>
              )}
              <span>{props.percent}%</span>
            </div>
          </div>
          <div className="progress mb-0">
            <div className={"progress-bar " + props.color} role="progressbar" style={barStyle}></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopHoldingsCard;
